import React, {useState, useEffect} from 'react';
import {View, Dimensions, StyleSheet} from 'react-native';
import {Button, Input, Text} from 'react-native-elements';
import HomeHeader from '../../components/HomeHeader';
import {Badge, Card, Col, Container, Row} from 'react-bootstrap';
import {useLinkTo} from '@react-navigation/native';
import {GetNetworkProvider} from '../../network/NetworkProvider';
import {getAccountId} from '../../database/DataBase';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default function RechargeScreen(props) {

  const context = GetNetworkProvider();
  
  const [isLoading, setIsLoading] = useState(false);
  const [amount, setAmount] = useState(0);
  const [errorMessage, setErrorMessage] = useState(null);
  const [accId, setAccId] = useState(null);
  
  const linkTo = useLinkTo();

  useEffect(() => {
    getAccountId().then((accountId) => {
      setAccId(accountId);
    }).catch((e)=> {
      console.log('Error fetching account ID');
    });
  }, [props]);

  useEffect(() => {
    let amt = 0;
    if (context.bouqueInfo) {
      context.bouqueInfo.forEach((item) => {
        amt += parseFloat(item.mrp);
      });
      setAmount(amt.toFixed(2));
    }
  }, [context]);

  const Id = context.profileInfo
    ? context.profileInfo.data
      ? context.profileInfo.data.profile.customer_id
        ? context.profileInfo.data.profile.customer_id
        : 'Loading...'
      : 'Loading...'
    : 'Loading...';

  const onSubmit = () => {
    if (amount != null && amount != '' && amount != 0) {
      setErrorMessage(null);
      return true;
    } else {
      setErrorMessage("Please enter amount");
      return false;
    }
  };

  const processInput = (amt) => {
    if (+amt || amt == "") {
      setAmount(amt);
    }
  };

  return (
    <View
      style={{
        height: HEIGHT,
      }}>
      <HomeHeader navigation={props.navigation} />
      <Container style={{marginTop: 30}}>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <View>
              <Text style={styles.header}>Quick {'&'} easy recharge</Text>
              <Text style={styles.headerBottom}>
                Enter your details below and get started
              </Text>
            </View>
          </Col>
          <Col md={3}></Col>
        </Row>

        {/* <Row>
          <Col md={3}></Col>
          <Col md={6} style={{alignSelf: 'center', justifyContent: 'center'}}> */}
        {/* </Col>
          <Col md={3}></Col>
        </Row> */}
      </Container>
      <View style={styles.inputContainer}>
        <Text style={styles.inputName}>
          Subscriber ID
        </Text>
        <Input
          placeholderTextColor="grey"
          value={Id}
          inputStyle={styles.inputStyle}
          //   onChangeText={onCustomerIdChangeText}
        />
        <Text style={styles.inputName}>Amount</Text>
        <Input
          value={amount}
          inputStyle={styles.inputStyle}
          placeholderTextColor="grey"
          onChangeText={(amt) => processInput(amt)}
          keyboardType = "numeric"
          errorMessage={errorMessage}
        />

        <form onSubmit={onSubmit} action="http://202.62.66.122/portal/index.php?r=portal/index/wallet-recharge" method="POST">
          <input type="hidden" name="amount" value={amount} />
          <input type="hidden" name="account_id" value={accId} />
          <input type="submit" value="Continue" disabled={Id == 'Loading...'} style={{color: 'white', backgroundColor: 'red', height: 50, width: '100%'}}/>
        </form>
        {/* <Button
          loading={isLoading}
          onPress={onPayment}
          raised
          containerStyle={styles.buttonContainerStyle}
          buttonStyle={styles.buttonStyle}
          title="Continue"
          disabled={Id == 'Loading...'}
        /> */}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    marginVertical: '25',
  },
  header: {
    color: '#ffd80e',
    alignSelf: 'center',
    fontSize: 35,
  },
  headerBottom: {
    color: '#c0c0c0',
    alignSelf: 'center',
    marginVertical: 15,
    letterSpacing: 1,
    fontSize: 15,
  },
  inputStyle: {color: 'white'},
  buttonStyle: {
    backgroundColor: 'red',
    height: 50,
  },
  buttonContainerStyle: {marginTop: 15},
  moreViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  inputName: {
    marginTop: 20,
    color: '#c0c0c0',
    letterSpacing: 1,
    marginLeft: 10,
  },
  inputContainer: {
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 4,
    alignSelf: 'center',
    justifyContent: 'center',
    marginTop: 5,
  },
});
